import { Box, CircularProgress } from '@mui/material';
import { ReactElement, useEffect, useState } from 'react';
import { useMounted } from '../../hooks/useMounted';

type Props = {
  permissionCallback: () => Promise<boolean>;
  noPermission: ReactElement;
  withPermission: ReactElement;
};

export const LoadingCell = ({ permissionCallback, noPermission, withPermission }: Props) => {
  const mountedRef = useMounted();
  const [loading, setLoading] = useState(true);
  const [hasPermission, setPermission] = useState(false);

  useEffect(() => {
    setLoading(true);

    permissionCallback()
      .then((permission) => {
        if (!mountedRef.current) {
          return;
        }

        setPermission(permission);
        setLoading(false);
      })
      .catch(() => {
        if (!mountedRef.current) {
          return;
        }

        setPermission(false);
        setLoading(false);
      });
  }, [mountedRef, permissionCallback]);

  if (loading) {
    return (
      <Box>
        <CircularProgress color="inherit" size="1rem" />
      </Box>
    );
  }

  if (hasPermission) {
    return withPermission;
  }

  return noPermission;
};
